import React from "react";
import "./MainHero.css";
//import MyImage from "../../assets/about.svg";

const MainHero = () => {
  return (
    <section className="w-full flex flex-wrap justify-center items-center pt-3 sm:pt-0">
      <div className="text-lg text-center flex flex-col justify-evenly md:text-xl">
        Hello, I am
        <h1 className="text-5xl md:text-8xl pt-3">Aniket Negi</h1>
        <p className="text-lg pt-3 md:text-xl">
          Front-end developer and designer.
        </p>
        <div className="flex justify-center items-center py-24">
          <a
            href="https://drive.google.com/file/d/1Uw5owJRL_oaA5I5_apr96g2dJU5H9d2Q/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="text-2xl rounded-sm border-solid border-2 border-yellow-300 
              hover:bg-gray1 hover:text-yellow-300 px-6 py-3 bg-yellow-300 text-gray1"
          >
            Resume !
          </a>
        </div>
        <div className="relative">
          <div id="scroll-down-animation">
            <a href="#about">
              <span className="mouse">
                <span className="move"></span>
              </span>
              <h2>Scroll down</h2>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainHero;
